import ListView, { ListViewItem } from "@ingka/list-view";
import checkmarkCircle from "@ingka/ssr-icon/paths/checkmark-circle";
import crossCircle from "@ingka/ssr-icon/paths/cross-circle";
import noticeCircle from "@ingka/ssr-icon/paths/notice-circle";
import SSRIcon from "@ingka/ssr-icon";
import { getInitials } from "@/utils/misc";
import { UploadDto, type UploadDtoStateEnum } from "generated";

type Props = {
  title: string;
  uploads: UploadDto[];
  onClick: (uploadId: number) => void;
};

const Column = ({ title, uploads, onClick }: Props) => {
  const getStateIcon = (state: UploadDtoStateEnum) => {
    switch (state) {
      case "DONE":
        return (
          <SSRIcon
            paths={checkmarkCircle}
            className="text-green-500"
            aria-label="Upload completed"
            ariaHidden={false}
          />
        );
      case "PARTIAL_APPROVED":
        return (
          <SSRIcon
            paths={noticeCircle}
            className="text-orange-500"
            aria-label="Upload partially approved"
            ariaHidden={false}
          />
        );
      case "DENIED":
        return (
          <SSRIcon
            paths={crossCircle}
            className="text-red-500"
            aria-label="Upload denied"
            ariaHidden={false}
          />
        );
      default:
        return null;
    }
  };

  const sortedUploads = [...uploads].sort((a, b) =>
    title === "Completed"
      ? new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      : 0,
  );
  return (
    <div className="h-full min-h-0 overflow-y-auto">
      <ListView id={title} size="medium" showDivider>
        {sortedUploads.map((upload) => (
          <ListViewItem
            key={`${title}-${upload.id}`}
            className="overview-item mb-space100 bg-white"
            showDivider
            inset
            emphasised
            description={upload.updatedAt.split("T")[0]}
            onClick={() => onClick(upload.id)}
            control="navigational"
            controlIcon="chevronRightSmall"
            title={`ID${upload.id}`}
            quantityLabel={getStateIcon(upload.state)}
            avatarProps={
              upload.assignee?.firstName
                ? {
                    screenReaderText: `Assignee: ${upload.assignee.firstName} ${upload.assignee.lastName}`,
                    text: getInitials(
                      upload.assignee.firstName,
                      upload.assignee.lastName,
                    ),
                  }
                : undefined
            }
          />
        ))}
      </ListView>
    </div>
  );
};

export default Column;
